export class FetchError extends Error {
  status: number | undefined;

  constructor(status?: number, message?: string) {
    super(message);
    if (status) {
      this.status = status;
    }
  }
}
